import React, { Component } from 'react';
import {
  Button,
} from 'react-bootstrap';
// icons
import Icon from 'react-icons/lib/go/plus';
// stores
import PasscodeStore from '../../stores/PasscodeStore';
// models
import Passcode from '../../models/Passcode';
// components
import PasscodeDialog from '../../components/Property/PasscodeDialog';
// css
import './Buttons.css';

class AddPropertyButton extends Component {
  constructor(props) {
    super(props);
    this.state = { showDialog: false };
  }

  render() {
    return (
      <Button bsStyle="primary" onClick={() => this.showDialog(true)}>
        <div className="Buttons-container">
          <div className="Buttons-icon"><Icon /></div>
          <div className="Buttons-text">Passcode</div>
        </div>
        <PasscodeDialog
          show={this.state.showDialog}
          passcode={new Passcode()}
          onSave={this.onSave}
          onCancel={() => this.showDialog(false)} />
      </Button>
    );
  }

  showDialog = (bShow = false) => {
    this.setState({ showDialog: bShow });
  }

  onSave = (passcode) => {
    if (passcode) {
      PasscodeStore.add(passcode);
      this.showDialog(false);
    }
  }
}

export default AddPropertyButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/AddPasscode.js